import { type ProspectDto, ProspectsService } from '@api'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast.tsx'
import { handleError } from '@/utils/error'

export const useAddProspect = () => {
  const queryClient = useQueryClient()
  const toast = useToast()

  const addMutation = useMutation(
    (body: ProspectDto) =>
      ProspectsService.createProspect({ requestBody: body }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['prospects'])
        toast.success('Prospect added successfully')
      },
      onError: (error) => {
        handleError(error, 'Failed to add prospect')
      },
    },
  )

  return {
    addProspect: addMutation.mutateAsync,
    isAddingProspect: addMutation.isLoading,
  }
}
